module.exports = __webpack_public_path__ + "static/media/lr.086aea48.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lr.svg
// module id = 2142
// module chunks = 0